import type { SimpleHeadlineResponse } from '@on3/api';
import { On3IconLockPremium } from '@on3/icons';
import { Link } from '@on3/ui-lib/components/Link';
import clsx from 'clsx';

import styles from './PremiumArticle.module.scss';

interface PremiumArticleProps extends SimpleHeadlineResponse {
  isModule?: boolean;
}

export const PremiumArticle = ({
  fullUrl,
  title,
  isModule = true,
}: PremiumArticleProps) => {
  return (
    <article
      className={clsx(styles.block, {
        [styles.module]: isModule,
      })}
      data-ui="feed-premium-article"
    >
      <Link className={styles.headline} href={fullUrl}>
        <h3>{title}</h3>
        <On3IconLockPremium className={styles.icon} />
      </Link>
    </article>
  );
};
